export default __webpack_public_path__ + "static/media/mw9.84fef4b0.webp";